import { useCallback, useEffect, useRef } from "react";
import telegramLogo from 'src/assets/images/Telegram.svg';
import './Footer.css';
import { footerHeight } from "./FooterHelper";
import ModalTelegram from "./ModalTelegram/ModalTelegram";

const Footer = () => {
  const modalTelegramRef = useRef();
  const footerRef = useRef();

  const telegramToggle = () => {
    modalTelegramRef.current.classList.toggle("modal-telegram__active");
  };

  const closeModalContactsHandler = (e) => {
    const modalTelegram = modalTelegramRef.current;
    const footer = footerRef.current;

    // if modal active
    modalTelegram.classList.contains("modal-telegram__active") &&

      // and not footer clicked so did not istant triggered
      !footer.contains(e.target) &&

      // and clicked everywhere but not in modal
      !modalTelegram.firstElementChild.contains(e.target) &&
      modalTelegram.classList.remove("modal-telegram__active");

  };

  // Footer observer
  const observerRef = useRef(null);

  const sentinelRef = useCallback((node) => {
    if (!node) return;

    if (observerRef.current) observerRef.current.disconnect();

    const observerOptions = {
      rootMargin: `0px 0px ${footerHeight} 0px`
    };

    const footerObserverCallback = ([entry]) => {
      if (entry.isIntersecting) footerRef.current.style.bottom = '0';
      else footerRef.current.style.bottom = `-${footerHeight}`;
    };

    observerRef.current = new IntersectionObserver(footerObserverCallback, observerOptions);

    observerRef.current.observe(node);
  }, []);


  useEffect(() => {
    document.addEventListener('click', closeModalContactsHandler);

    return () => {
      document.removeEventListener('click', closeModalContactsHandler);
    };
  },
    []);

  return (
    <>
      <div className="sentinel" ref={sentinelRef} />
      <section className="footer" ref={footerRef}>
        <button className="footer-link" onClick={telegramToggle}>
          Turner &copy; <span>{new Date().getFullYear()}</span>
          <a
            href="https://telegram.me/turner_cola"
            target="_blank"
            rel="noreferrer"
          >
            <img src={telegramLogo} className="telegram" />
          </a>
        </button>
        <div className="modal-telegram" ref={modalTelegramRef}>
          <ModalTelegram />
        </div>
      </section>
    </>
  );
};

export default Footer;
